import React, { useRef } from 'react';
import { Box } from '@chakra-ui/react';
import { motion, useInView } from 'framer-motion';

const MotionBox = motion.create(Box);

const fadeUp = {
	hidden: { opacity: 0, y: 28 },
	visible: (i = 0) => ({
		opacity: 1,
		y: 0,
		transition: { duration: 0.55, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
	}),
};

const Reveal = ({ children, delay = 0, ...props }) => {
	const ref = useRef(null);
	const inView = useInView(ref, { once: true, margin: '-60px' });
	return (
		<MotionBox
			ref={ref}
			initial='hidden'
			animate={inView ? 'visible' : 'hidden'}
			variants={fadeUp}
			custom={delay}
			{...props}>
			{children}
		</MotionBox>
	);
};

export default Reveal;
